module.exports = __webpack_public_path__ + "static/media/PW.3726c623.png";